document.addEventListener('DOMContentLoaded', function () {

  /* ============================================================
     UTILITY
  ============================================================ */
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ============================================================
     CART — uses item.key (not variant_id) for cart/change.js
  ============================================================ */
  async function getCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }

  function updateCartCount(n) {
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  async function renderCart() {
    const cart = await getCart();
    updateCartCount(cart.item_count);

    const itemsEl  = document.getElementById('cart-items');
    const footerEl = document.getElementById('cart-footer');
    const subtotalEl = document.getElementById('cart-subtotal');
    const shipFill   = document.getElementById('ship-fill');
    const shipLabel  = document.getElementById('ship-label');

    if (!itemsEl) return;

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-empty-msg">Your cart is empty. <a href="/collections/all" style="color:var(--brand-red-deep);font-weight:600;">Browse kits →</a></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    // Use item.key — required by /cart/change.js
    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <img class="cart-item__img" src="${item.image}" alt="${item.product_title}">
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__row">
            <div class="cart-item__qty">
              <button class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
              <span class="cart-qty-num">${item.quantity}</span>
              <button class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
            </div>
            <span class="cart-item__price">${fmt(item.line_price)}</span>
          </div>
          <button class="cart-item__remove" data-key="${item.key}" data-qty="0">Remove</button>
        </div>
      </div>
    `).join('');

    if (footerEl) footerEl.style.display = 'block';
    if (subtotalEl) subtotalEl.textContent = fmt(cart.total_price);

    // Shipping progress bar — $1,500 threshold
    const freeAt = 150000;
    const pct = Math.min((cart.total_price / freeAt) * 100, 100);
    if (shipFill) shipFill.style.width = pct + '%';
    if (shipLabel) {
      if (cart.total_price >= freeAt) {
        shipLabel.textContent = '🎉 Free shipping unlocked!';
        shipLabel.style.color = 'var(--brand-red-deep)';
        shipLabel.style.fontWeight = '600';
      } else {
        const rem = fmt(freeAt - cart.total_price);
        shipLabel.textContent = `Add ${rem} more for free shipping`;
        shipLabel.style.color = '';
        shipLabel.style.fontWeight = '';
      }
    }
  }

  // Delegated qty/remove handler — works on dynamically rendered items
  document.addEventListener('click', function(e) {
    const qtyBtn = e.target.closest('.cart-qty-btn, .cart-item__remove');
    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const qty = parseInt(qtyBtn.dataset.qty);
      if (key !== undefined && !isNaN(qty)) changeQty(key, qty);
      return;
    }
    if (e.target.closest('[data-cart-open]')) { openCart(); return; }
    if (e.target.closest('.cart-drawer__close') || e.target.closest('.cart-drawer__overlay')) { closeCart(); return; }
  });

  window.changeQty = async function(key, qty) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    });
    await renderCart();
  };

  window.addToCart = async function(variantId, qty, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      });
      if (!r.ok) throw new Error('Add failed');
      await renderCart();
      openCart();
    } catch(err) {
      console.error('addToCart error:', err);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
    }
  };

  function openCart() {
    document.getElementById('cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  }

  renderCart();

  /* ============================================================
     EMAIL POPUP — posts to Shopify /contact for newsletter
  ============================================================ */
  const popup       = document.getElementById('email-popup');
  const popupForm   = document.getElementById('popup-email-form');
  const popupInput  = document.getElementById('popup-email-input');
  const popupSubmit = document.getElementById('popup-submit-btn');
  const popupSuccess= document.getElementById('popup-success');

  function closePopup() {
    if (popup) popup.style.display = 'none';
    localStorage.setItem('qep_popup', '1');
  }

  if (popupForm) {
    popupForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const email = popupInput?.value?.trim();
      if (!email) return;
      if (popupSubmit) { popupSubmit.disabled = true; popupSubmit.textContent = 'Sending...'; }
      try {
        // Submit via Shopify contact form — tags as newsletter subscriber
        const fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('customer[email]', email);
        fd.append('customer[tags]', 'newsletter,popup-guide');
        await fetch('/contact', { method: 'POST', body: fd });
      } catch(err) { /* silent fail — still show success */ }
      // Show success regardless (form works even if fetch has CORS issues)
      if (popupForm) popupForm.style.display = 'none';
      if (popupSuccess) popupSuccess.style.display = 'block';
      localStorage.setItem('qep_popup', '1');
      setTimeout(closePopup, 3500);
    });
  }

  document.querySelector('.email-popup__close')?.addEventListener('click', closePopup);
  document.querySelector('.email-popup__overlay')?.addEventListener('click', closePopup);

  // Show popup after 12 seconds on first visit
  if (!localStorage.getItem('qep_popup') && popup) {
    setTimeout(() => { popup.style.display = 'flex'; }, 12000);
  }


  /* Header disclosure navigation: click/touch/keyboard, escape, outside click. */
  const navGroups = Array.from(document.querySelectorAll('.qep-desktop-nav .qep-nav-group'));
  navGroups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) navGroups.forEach(other => { if (other !== group) other.open = false; });
  }));
  document.addEventListener('click', e => {
    navGroups.forEach(group => { if (!group.contains(e.target)) group.open = false; });
  });
  const mobileToggle = document.querySelector('.qep-mobile-toggle');
  const mobileNav = document.querySelector('.qep-mobile-nav');
  const closeMobileNav = (restoreFocus = false) => {
    if (!mobileNav || !mobileToggle) return;
    mobileNav.hidden = true;
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.setAttribute('aria-label', 'Open navigation menu');
    if (restoreFocus) mobileToggle.focus();
  };
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const opening = mobileNav.hidden;
      mobileNav.hidden = !opening;
      mobileToggle.setAttribute('aria-expanded', String(opening));
      mobileToggle.setAttribute('aria-label', opening ? 'Close navigation menu' : 'Open navigation menu');
    });
    document.addEventListener('click', e => {
      if (!mobileNav.hidden && !e.target.closest('.qep-header')) closeMobileNav();
    });
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1040 && !mobileNav.hidden) closeMobileNav();
    });
    mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeMobileNav()));
  }
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      navGroups.forEach(group => {
        if (group.open) {group.open = false;group.querySelector('summary')?.focus();}
      });
      if (mobileNav && !mobileNav.hidden) closeMobileNav(true);
    }
  });

  /* ============================================================
     FAQ
  ============================================================ */
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const ans = btn.nextElementSibling;
      const isOpen = btn.classList.contains('open');
      document.querySelectorAll('.faq-q.open').forEach(oq => {
        oq.classList.remove('open');
        oq.nextElementSibling?.classList.remove('open');
      });
      if (!isOpen) { btn.classList.add('open'); ans?.classList.add('open'); }
    });
  });

  /* ============================================================
     GALLERY FILTER
  ============================================================ */
  document.querySelectorAll('.gallery-filter').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.gallery-filter').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('.gallery-item').forEach(item => {
        item.style.display = (filter === 'all' || item.dataset.category === filter) ? '' : 'none';
      });
    });
  });

  /* ============================================================
     CALCULATOR
  ============================================================ */
  window.calcKits = function() {
    const l = parseFloat(document.getElementById('calc-l')?.value) || 0;
    const w = parseFloat(document.getElementById('calc-w')?.value) || 0;
    const r = parseInt(document.getElementById('calc-r')?.value) || 1;
    const sqft     = Math.round(l * w * r);
    const buffered = Math.ceil(sqft * 1.15);
    const kits     = Math.ceil(buffered / 100);
    const priceCents = Number(document.getElementById('qep-calculator')?.dataset.kitPriceCents || 0);
    const price = kits * priceCents / 100;
    const set = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
    set('res-sqft', sqft > 0 ? sqft.toLocaleString() : '—');
    set('res-kits', kits > 0 ? kits : '—');
    set('res-price', kits > 0 && priceCents > 0 ? 'From $' + price.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : '—');
    const addBtn = document.getElementById('calc-add');
    if (addBtn) addBtn.style.display = kits > 0 ? '' : 'none';
  };

  /* ============================================================
     PRODUCT GALLERY THUMBS
  ============================================================ */
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const main = document.getElementById('main-product-img');
      const src = thumb.dataset.imageSrc;
      if (main && src) {
        main.src = src;
        main.removeAttribute('srcset');
        main.alt = thumb.dataset.imageAlt || main.alt;
      }
      document.querySelectorAll('.product-gallery__thumb').forEach(t => {
        t.classList.remove('active'); t.setAttribute('aria-pressed', 'false');
      });
      thumb.classList.add('active'); thumb.setAttribute('aria-pressed', 'true');
    });
  });

  /* ============================================================
     QTY STEPPERS (product page)
  ============================================================ */
  document.querySelectorAll('.qty-stepper').forEach(stepper => {
    stepper.querySelectorAll('[data-action]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = stepper.querySelector('.qty-stepper__input, input[type="number"]');
        if (!input) return;
        const val = parseInt(input.value) || 1;
        input.value = btn.dataset.action === 'minus' ? Math.max(1, val - 1) : val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ============================================================
     PRODUCT PAGE QTY → SQFT
  ============================================================ */
  const pQtyInput  = document.getElementById('product-qty-input');
  const sqftDisplay = document.getElementById('product-sqft-display');
  if (pQtyInput && sqftDisplay) {
    pQtyInput.addEventListener('change', () => {
      sqftDisplay.textContent = ((parseInt(pQtyInput.value) || 1) * 100).toLocaleString();
    });
  }

  /* ============================================================
     PRODUCT TABS
  ============================================================ */
  document.querySelectorAll('.product-tab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      document.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(target)?.classList.add('active');
    });
  });

  /* ============================================================
     VARIANT SELECTION
  ============================================================ */
  window.selectVariant = function(el, variantId, title, price, available) {
    document.querySelectorAll('.product-swatch').forEach(s => s.classList.remove('active'));
    el.classList.add('active');
    const labelEl = document.getElementById('selected-color-label');
    if (labelEl) labelEl.textContent = title;
    const priceEl = document.getElementById('product-price-display');
    if (priceEl) priceEl.textContent = '$' + (price / 100).toFixed(2);
    const addBtn = document.getElementById('atc-btn');
    if (addBtn) {
      addBtn.textContent = available ? 'Add to Cart' : 'Out of Stock';
      addBtn.disabled = !available;
      addBtn.onclick = available ? () => {
        const qty = parseInt(document.getElementById('product-qty-input')?.value) || 1;
        addToCart(variantId, qty, addBtn);
      } : null;
    }
    const img = el.querySelector('img');
    const mainImg = document.getElementById('main-product-img');
    if (img && mainImg) { mainImg.src = img.src.replace(/width=\d+/, 'width=1100'); mainImg.removeAttribute('srcset'); mainImg.alt = title; }
  };

  /* ============================================================
     SCROLL ANIMATIONS
  ============================================================ */
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('anim-up'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  document.querySelectorAll('.kit-card, .testimonial-card, .color-card, .step-card, .segment-card').forEach(el => obs.observe(el));

});
